/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ImageDto
 */
export interface ImageDto {
  /**
   *
   * @type {string}
   * @memberof ImageDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ImageDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof ImageDto
   */
  blur: string;
  /**
   *
   * @type {string}
   * @memberof ImageDto
   */
  width: string;
  /**
   *
   * @type {string}
   * @memberof ImageDto
   */
  height: string;
}

export function ImageDtoFromJSON(json: any): ImageDto {
  return ImageDtoFromJSONTyped(json, false);
}

export function ImageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    url: json["url"],
    blur: json["blur"],
    width: json["width"],
    height: json["height"],
  };
}

export function ImageDtoToJSON(value?: ImageDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    url: value.url,
    blur: value.blur,
    width: value.width,
    height: value.height,
  };
}
